import type { ComponentProps } from 'react';

const InfoIcon = (props: ComponentProps<'svg'>) => {
  const { fill = 'grey', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      {...rest}
    >
      <g clip-path="url(#clip0_6338_2936)">
        <path
          d="M6 11.0703C4.78788 11.0703 3.6254 10.5888 2.7683 9.7317C1.9112 8.8746 1.42969 7.71212 1.42969 6.5C1.42969 5.28788 1.9112 4.1254 2.7683 3.2683C3.6254 2.4112 4.78788 1.92969 6 1.92969C7.21212 1.92969 8.3746 2.4112 9.2317 3.2683C10.0888 4.1254 10.5703 5.28788 10.5703 6.5C10.5703 7.71212 10.0888 8.8746 9.2317 9.7317C8.3746 10.5888 7.21212 11.0703 6 11.0703ZM6 0.875C4.50816 0.874999 3.07742 1.46763 2.02252 2.52252C0.967633 3.57742 0.375001 5.00816 0.375 6.5C0.375 7.99184 0.967632 9.42258 2.02252 10.4775C3.07742 11.5324 4.50816 12.125 6 12.125C7.49184 12.125 8.92258 11.5324 9.97748 10.4775C11.0324 9.42258 11.625 7.99184 11.625 6.5C11.625 5.00816 11.0324 3.57742 9.97748 2.52252C8.92258 1.46763 7.49184 0.875 6 0.875ZM6 9.3125C6.29224 9.3125 6.52734 9.07739 6.52734 8.78516L6.52734 6.32422C6.52734 6.03198 6.29224 5.79687 6 5.79687C5.70776 5.79687 5.47266 6.03198 5.47266 6.32422L5.47266 8.78516C5.47266 9.07739 5.70776 9.3125 6 9.3125ZM5.29688 4.39062C5.29688 4.5771 5.37095 4.75595 5.50282 4.88781C5.63468 5.01967 5.81352 5.09375 6 5.09375C6.18648 5.09375 6.36532 5.01967 6.49718 4.88781C6.62905 4.75595 6.70313 4.5771 6.70313 4.39062C6.70313 4.20414 6.62905 4.0253 6.49719 3.89344C6.36532 3.76158 6.18648 3.6875 6 3.6875C5.81352 3.6875 5.63468 3.76158 5.50282 3.89344C5.37095 4.0253 5.29688 4.20414 5.29688 4.39062Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_6338_2936">
          <rect
            width="11.25"
            height="11.25"
            fill="white"
            transform="translate(11.625 12.125) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoIcon;
